import { StyleSheet } from "@react-pdf/renderer";

// Tailwindcss Spacing Design System: https://tailwindcss.com/docs/theme#spacing
// It is converted from rem to pt (1rem = 12pt) since https://react-pdf.org/styling only accepts pt unit
export const spacing = {
  0: "0",
  0.5: "1.5pt",
  1: "3pt",
  1.5: "4.5pt",
  2: "6pt",
  2.5: "7.5pt",
  3: "9pt",
  3.5: "10.5pt",
  4: "12pt",
  5: "15pt",
  6: "18pt",
  7: "21pt",
  8: "24pt",
  9: "27pt",
  10: "30pt",
  11: "33pt",
  12: "36pt",
  14: "42pt",
  16: "48pt",
  20: "60pt",
  24: "72pt",
  28: "84pt",
  32: "96pt",
  36: "108pt",
  40: "120pt",
  44: "132pt",
  48: "144pt",
  52: "156pt",
  56: "168pt",
  60: "180pt",
  64: "192pt",
  72: "216pt",
  80: "240pt",
  96: "288pt",
  full: "100%",
} as const;

export const styles = StyleSheet.create({
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  flexRowBetween: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  flexCol: {
    display: "flex",
    flexDirection: "column",
  },
  icon: {
    width: "13pt",
    height: "13pt",
    fill: "#525252", // text-neutral-600
  },
  // Base text styles with tighter line height for better space utilization
  text: {
    fontSize: "11pt", // Base font size - will be overridden dynamically
    lineHeight: 1.2, // Reduced from 1.3 for better content density
  },
  // Heading text styles
  heading: {
    fontSize: "11pt", // Base font size - will be overridden dynamically
    lineHeight: 1.15, // Reduced from 1.2 for tighter headings
    fontWeight: "bold",
  },
  // Bullet point text styles  
  bulletText: {
    fontSize: "11pt", // Base font size - will be overridden dynamically
    lineHeight: 1.2, // Reduced from 1.3 for better bullet spacing
  }
});

/**
 * Get dynamic styles based on user's fontSize setting
 * This ensures proper spacing and typography scaling across all templates
 */
export const getDynamicStyles = (fontSize: string) => {
  const fontSizePt = `${fontSize}pt`;
  
  return {
    text: {
      ...styles.text,
      fontSize: fontSizePt,
    },
    heading: {
      ...styles.heading,
      fontSize: fontSizePt,
    },
    bulletText: {
      ...styles.bulletText,
      fontSize: fontSizePt,
    },
  };
};
